import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { admin } from './admin-api';

// RBAC (spec 12.5): the append-only audit trail — who did what (auth, role/owner changes,
// dispositions). Superadmin-only (the admin router is superadmin-gated). Read-only.

export default function Audit() {
  const [action, setAction] = useState('');
  const [actor, setActor] = useState('');
  const filters = { action: action || undefined, actor: actor.trim() || undefined };
  const events = useQuery({ queryKey: ['admin', 'audit', filters], queryFn: () => admin.audit(filters) });

  return (
    <div>
      <div className="ph">Admin · Audit Trail</div>
      <div className="h2">Append-only audit log</div>
      <p className="lead">Every auth event, role / owner change, and disposition — who, what, when.</p>

      <div className="panel" style={{ marginBottom: 14 }}>
        <div className="qhead"><span className="qdot" style={{ background: 'var(--amber)' }} />Filter</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div>
            <label className="small faint" style={{ display: 'block', marginBottom: 6, fontSize: 12, textTransform: 'uppercase' }}>Action</label>
            <input className="c2-input" value={action} onChange={(e) => setAction(e.target.value)} placeholder="e.g. auth.login" />
          </div>
          <div>
            <label className="small faint" style={{ display: 'block', marginBottom: 6, fontSize: 12, textTransform: 'uppercase' }}>Actor</label>
            <input className="c2-input" value={actor} onChange={(e) => setActor(e.target.value)} placeholder="email or 'passcode'" />
          </div>
        </div>
      </div>

      <div className="panel">
        <div className="qhead"><span className="qdot" style={{ background: 'var(--teal)' }} />{events.data?.length ?? 0} events</div>
        {events.isLoading ? (
          <div className="small faint">Loading…</div>
        ) : (
          <table>
            <thead>
              <tr><th>When</th><th>Action</th><th>Actor</th><th>Target</th><th>Detail</th></tr>
            </thead>
            <tbody>
              {events.data?.map((e) => (
                <tr key={e.id}>
                  <td className="small faint">{new Date(e.ts).toLocaleString()}</td>
                  <td className="small"><span className="tag muted">{e.action}</span></td>
                  <td className="small">{e.actor}</td>
                  <td className="small">{e.target ?? '—'}</td>
                  <td className="small faint mono" style={{ maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {Object.keys(e.detail).length ? JSON.stringify(e.detail) : '—'}
                  </td>
                </tr>
              ))}
              {!events.data?.length && <tr><td colSpan={5} className="small faint">No audit events match.</td></tr>}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
